import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { Company } from '../db/Company.js';

export const searchCompanies = registerQuery({
  operationName: 'searchCompanies',
  type: () => [Company],
  params: [{ name: 'searchString', type: () => String }],
  resolve: (searchString: string) => async (gqlFields: BaseQLSelectionSet<Company>) => {
    const trimmed = searchString.trim();
    if (!trimmed) return [];

    const collection = await getRawCollection<Company>(Company._collectionName);

    const tokens = trimmed.split(/[\s,;]+/).filter(t => t.length > 0);
    if (tokens.length === 0) return [];

    const conditions = tokens.map(token => {
      const escaped = token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = { $regex: escaped, $options: 'i' };
      return {
        $or: [{ debitor: regex }, { name: regex }, { city: regex }],
      };
    });

    const filter = conditions.length === 1 ? conditions[0]! : { $and: conditions };
    const results = await collection.find(filter).limit(50).toArray();
    return results.map(r => new Company(r));
  },
});
